import {BrowserModule, Title} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {NgModule} from "@angular/core";
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ResponsiveModule} from "ng2-responsive";
import {AppComponent, weightDisputeComponent} from "./app.component";
import {AppState, InternalStateType} from "./app.service";
import {GlobalState} from "./app.state";
import {ServicesModule} from "./shared/services/services.module";
import {SharedModule} from "./shared/shared.module";
import {AppRoutingModule} from "./app.routing";
import {LocalStorageTodoService} from "./shared/services/localstorage/localstorage-todo.service";
import {HttpClientModule} from "@angular/common/http";
import { AngularFireModule } from "angularfire2";
import { environment } from "../environments/environment";
import { FacebookModule } from 'ngx-facebook';
import {MatDialogModule} from "@angular/material";
import { MomentModule } from 'angular2-moment';
import { OrderService } from './shared/services/httpservice/order.service';
import { RouterModule } from "@angular/router";
// import { ProcessRemittanceComponent } from './process-remittance/process-remittance.component';
// import {PopupModule} from 'ng2-opd-popup';

// import {MdDialogModule} from 'md-dialog/dialog';

//import { InMemoryTodoService } from "./shared/services/inMemory/in-memory-todo.service";
// Application wide providers
const APP_PROVIDERS = [AppState, GlobalState, Title, LocalStorageTodoService, OrderService];
const ECOM_PRODUCTS_ROUTE = [{ path: "", component: weightDisputeComponent  }];

export type StoreType = {
    state: InternalStateType;
    restoreInputValues: () => void;
    disposeOldHosts: () => void;
};

@NgModule({
    declarations: [AppComponent, weightDisputeComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ServicesModule,
        ResponsiveModule,
        SharedModule.forRoot(),
        AppRoutingModule,
        AngularFireDatabaseModule,
        MatDialogModule,
        AngularFireAuthModule,
        AngularFireModule.initializeApp(environment.firebase),
        FacebookModule.forRoot(),
        MomentModule,
        RouterModule.forChild(ECOM_PRODUCTS_ROUTE)
        // PopupModule.forRoot()
    ],
    providers: [APP_PROVIDERS],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(public appState: AppState) {
    }
}
